import { render, staticRenderFns } from "./issueBox.vue?vue&type=template&id=331ae5f1&scoped=true&"
import script from "./issueBox.vue?vue&type=script&lang=js&"
export * from "./issueBox.vue?vue&type=script&lang=js&"
import style0 from "./issueBox.vue?vue&type=style&index=0&id=331ae5f1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331ae5f1",
  null
  
)

export default component.exports